import { Checkbox, Tooltip, Typography } from "@mui/material";
import PermissionWrapper from "../../../global/PermissionWrapper";
import ReferralFrom from "../components/ReferralFrom";
import ReferralTo from "../components/ReferralTo";
import ProviderTypes from "../components/ProviderType";
import Status from "../components/Status";
import Source from "../components/Source";
import { Cancel, Check, Edit, Info } from "@mui/icons-material";
import CustomIconButton from "../../../ui library/components/buttons/CustomIconButton";
import CustomHtmlTooltip from "../../../ui library/components/tooltips/custom-html-tooltip";
import FormatISODateTime from "../../../global/FormatISODateTime";
import ReferredDate from "../components/ReferredDate";
import { STRINGS } from "../utils/Strings";

export default function getReferralColumns({
  permissions,
  selectedReferrals,
  handleCheckbox,
  editingRow,
  selectedReferralFrom,
  providerRepository,
  handleOnEditRow,
  selectedReferralTo,
  setReferralTo,
  setSelectedProviderType,
  setMode,
  referralTo,
  selectedProviderType,
  providerTypesRepository,
  mode,
  selectedReferralDate,
  selectedStatus,
  fieldOptionRepository,
  statuses,
  selectedSource,
  sources,
  handleSaveEditing,
  handleCancelEditing,
  handleStartEditing,
  row,
  ...rest
}) {
  return [
    {
      field: "id",
      headerName: "",
      width: 10,
      align: "center",
      headerAlign: "center",
      editable: false,
      renderCell: ({ row }) => (
        <>
          <PermissionWrapper permission={permissions.DELETE}>
            <div className="flex justify-center items-center h-full">
              <Checkbox
                checked={selectedReferrals.includes(row.id)}
                onChange={(e) => handleCheckbox(e, row.id)}
              />
            </div>
          </PermissionWrapper>
        </>
      ),
    },
    {
      field: "referredFrom",
      headerName: "Referred From Provider",
      width: 200,
      align: "center",
      headerAlign: "center",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {editingRow && editingRow[row?.id] ? (
            <div className="flex flex-col items-center justify-center p-2">
              <ReferralFrom
                initValue={selectedReferralFrom}
                repository={providerRepository}
                onChange={(param, value) =>
                  handleOnEditRow(row?.id, param, value)
                }
              />
            </div>
          ) : (
            <div className="flex justify-center items-center h-full">
              {row?.referralFrom?.name}
            </div>
          )}
        </>
      ),
    },
    {
      field: "referredTo",
      headerName: "Referred To Provider",
      width: 200,
      align: "center",
      headerAlign: "center",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {editingRow && editingRow[row?.id] ? (
            <div className="flex flex-col items-center justify-center p-2">
              <ReferralTo
                initValue={selectedReferralTo}
                repository={providerRepository}
                onChange={(field, value) => {
                  handleOnEditRow(row?.id, field, value);
                  if (field === "referralTo") {
                    setReferralTo(value);
                    if (!value) {
                      handleOnEditRow(row?.id, "providerType", null);
                    }
                    setSelectedProviderType(null);
                    setMode(STRINGS.MODE.CREATE);
                  }
                }}
              />
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center w-full h-full">
              <Typography className="text-black text-sm font-inherit">
                {row?.referralTo?.name}
              </Typography>
              {row?.providerType?.id ? (
                <Typography className="text-xs text-slate-500 text-center w-full italic">
                  {"( " + row?.providerType.name + " )"}
                </Typography>
              ) : (
                ""
              )}
            </div>
          )}
        </>
      ),
    },
    {
      field: "providerTypes",
      headerName: "Provider Type",
      width: 200,
      align: "center",
      headerAlign: "center",
      editable: false,
      renderCell: ({ row }) => {
        if (editingRow && editingRow[row?.id]) {
          return (
            <div className="flex flex-col items-start justify-center p-2">
              <ProviderTypes
                key={referralTo?.id || row?.id}
                mode={mode}
                initValue={selectedProviderType}
                repository={providerTypesRepository}
                referralTo={referralTo}
                onChange={(param, value) => {
                  return handleOnEditRow(row?.id, param, value);
                }}
                providerTypes={
                  referralTo === null ? [] : referralTo?.providerTypes || []
                }
              />
            </div>
          );
        }
      },
    },
    {
      field: "referredDate",
      headerName: "Referred Date",
      width: 200,
      align: "center",
      headerAlign: "center",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {editingRow && editingRow[row?.id] ? (
            <div className="flex flex-col items-start justify-center p-2">
              <ReferredDate
                initValue={selectedReferralDate}
                onChange={(param, value) => {
                  handleOnEditRow(row?.id, param, value);
                }}
              />
            </div>
          ) : (
            <div className="flex justify-center items-center h-full">
              {row?.referredAt}
            </div>
          )}
        </>
      ),
    },
    {
      field: "status",
      headerName: "Status",
      width: 100,
      align: "center",
      headerAlign: "center",
      editable: false,
      renderCell: ({ row }) => {
        if (editingRow && editingRow[row?.id]) {
          return (
            <div className="flex flex-col items-start justify-center p-2">
              <Status
                initValue={selectedStatus}
                repository={fieldOptionRepository}
                onChange={(param, value) =>
                  handleOnEditRow(row?.id, param, value)
                }
              />
            </div>
          );
        } else {
          const statusObj = statuses.find((s) => s.key === row.status);
          return (
            <div className="flex justify-center items-center h-full">
              {statusObj ? statusObj.label : row?.status}
            </div>
          );
        }
      },
    },
    {
      field: "source",
      headerName: "Source",
      width: 100,
      align: "center",
      headerAlign: "center",
      editable: false,
      renderCell: ({ row }) => {
        if (editingRow && editingRow[row?.id]) {
          return (
            <div className="flex flex-col items-start justify-center p-2">
              <Source
                initValue={selectedSource}
                repository={fieldOptionRepository}
                onChange={(param, value) =>
                  handleOnEditRow(row?.id, param, value)
                }
              />
            </div>
          );
        } else {
          const sourceObj = sources.find((s) => s.key === row.source);
          return (
            <div className="flex justify-center items-center h-full">
              {sourceObj ? sourceObj.label : row?.source}
            </div>
          );
        }
      },
    },
    {
      field: "actions",
      headerName: "",
      width: "200",
      align: "right",
      headerAlign: "center",
      editable: false,
      renderCell: ({ row }) => (
        <>
          {editingRow && editingRow[row?.id] ? (
            <div className="flex flex-row gap-2 justify-center items-center h-full">
              <CustomIconButton
                iconVisible
                tooltipText="Submit"
                CustomIcon={<Check className="text-green-500" />}
                handleOnClick={() => handleSaveEditing(row.id)}
              />
              <CustomIconButton
                iconVisible
                tooltipText="Cancel"
                CustomIcon={<Cancel className="text-red-500" />}
                handleOnClick={() => handleCancelEditing(row.id)}
              />
            </div>
          ) : (
            <div className="flex flex-row gap-2 justify-center items-center h-full">
              <CustomIconButton
                iconVisible
                disabled={!permissions.UPDATE}
                tooltipText={`${permissions.UPDATE ? "Edit Referral" : "No permission to edit the referral/s"}`}
                CustomIcon={
                  <Edit
                    className={`${permissions.UPDATE ? "text-blue-700" : "text-gray-500"}`}
                  />
                }
                handleOnClick={() => handleStartEditing(row.id)}
              />
              <CustomHtmlTooltip
                ToolTipContent={
                  <div className="flex flex-col gap-1 p-2">
                    <Typography className="text-white text-xs">
                      <span className="font-bold">
                        {row.updatedBy?.name ? "Updated At: " : "Created At: "}
                      </span>
                      {FormatISODateTime(
                        new Date(
                          row.updatedBy?.name ? row.updatedAt : row.createdAt
                        ).toISOString()
                      )}
                    </Typography>
                    <Typography className="text-white text-xs">
                      <span className="font-bold">
                        {row.updatedBy?.name ? "Updated By: " : "Created By: "}
                      </span>
                      {row.updatedBy?.name
                        ? row.updatedBy.name
                        : row.createdBy.name}
                    </Typography>
                  </div>
                }
              >
                <Info className="text-black hover: cursor-pointer" />
              </CustomHtmlTooltip>
            </div>
          )}
        </>
      ),
    },
  ];
}
